class PostGrid {
  constructor(element, ...options) {
    this.defaults = {
      buttonSelector: '.js-button-read-more',
      postItemsSelector: '.js-post-items',
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.buttonReadMore = this.element.querySelector(this.options.buttonSelector);
    this.postItems = this.element.querySelector(this.options.postItemsSelector);
    this.postOffset = 9;
    this.postType = this.element.dataset.type || '';

    this.bindEvents();
  }

  disableLoad() {
    this.buttonReadMore.classList.add('invisible');
  }

  insertPosts(data) {
    if (data.count < 9) {
      this.disableLoad();
    }

    if (data.count > 0) {
      this.postItems.innerHTML += data.html;
    }
  }

  loadPosts(event) {
    event.preventDefault();

    fetch(`/wp-admin/admin-ajax.php?action=get_more_posts&offset=${this.postOffset}&post_type=${this.postType}`, {
    })
      .then(response => response.json())
      .then(this.insertPosts.bind(this))
      .catch(error => console.error(error));

    this.postOffset += 9;
  }

  bindEvents() {
    if (this.buttonReadMore) {
      this.buttonReadMore.addEventListener('click', this.loadPosts.bind(this));
    }
  }
}
